import React, { useState } from 'react';
import BlueButtonBig from '../BlueButtonBig';
import FormInput from '../FormInput';
import { useTranslation } from 'react-i18next';
import { useRouter } from 'next/router';
import { useForm } from 'react-hook-form';
import FormErrorMessage from '../FormErrorMessage';
import localizedRoute from '../../utils/localizedRoute';
import { isEmpty } from 'lodash';
import { getLangCountry } from '../../helpers/languages';
import { useAlert } from '../../context/AlertProvider';
import Spinner from '../Spinner';
import { forgot } from '../../fetchers/password';
import { getToken } from '../../helpers/auth';
import LinkTo from '../LinkTo';

const EmailForm = () => {
  const { t } = useTranslation();
  const router = useRouter();
  const alert = useAlert();
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const {
    register,
    handleSubmit,
    formState: { errors }
  } = useForm({ defaultValues: { email: '' } });
  const { lang, country } = getLangCountry(router.query);
  const token = getToken();

  const onSubmit = async ({ email }: { email: string }) => {
    setLoading(true);
    try {
      await forgot({ lang, country, token, email });
      setSuccess(true);
    } catch (error) {
      alert.error(t('GENERIC_ERROR'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <div className="flex flex-col-reverse justify-between items-left mb-3 md:flex-row md:items-center">
        <h3 className="text-3xl font-sans">{t('RECOVER_PASSWORD')}</h3>
        <LinkTo
          href={localizedRoute('/login')}
          className="text-primary mb-3 md:mb-0"
        >
          {t('GO_BACK')}
        </LinkTo>
      </div>

      {success ? (
        <p className="text-sm opacity-60 mb-4">{t('FORGOT_SUCCESS_TEXT')}</p>
      ) : (
        <>
          <p className="text-sm opacity-60 mb-4">{t('EMAIL_FORM_TEXT')}</p>

          <form onSubmit={handleSubmit(onSubmit)}>
            <FormInput
              label="Email"
              type="email"
              id="email"
              placeholder={t('MAIL_ADDRESS')}
              invalid={Boolean(errors.email)}
              {...register('email', {
                required: t('REQUIRED_FIELD') as string,
                pattern: {
                  value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,10}$/i,
                  message: t('INVALID_EMAIL')
                }
              })}
            />
            <FormErrorMessage errors={errors} name="email" />

            <div className="mt-4">
              {loading ? (
                <Spinner />
              ) : (
                <BlueButtonBig
                  type="submit"
                  text={t('SEND')}
                  className="bg-primary text-white"
                  disabled={!isEmpty(errors)}
                />
              )}
            </div>
          </form>
        </>
      )}
    </div>
  );
};

export default EmailForm;
